import { directDottedConstants } from '../constants/directDoted.constants';
const initialState = {
	memberList : [],
	status: false,
};

const DirectDotedReducer = (state = initialState, action) => {
	switch (action.type) {
		case directDottedConstants.INITIAL_UPDATE_ACTIVE_TAB: 
			//console.log(action.data,"action.data");
			 return {
				 ...state,
				 activeTab:action.data
			 }
		case directDottedConstants.GET_MEMBER_SUCCESS:
			return {
				...state,
				memberList: action.data,
				status: !state.status
			};
		case directDottedConstants.GET_MEMBER_FAIL:
			return {
				...state,
		};
		case directDottedConstants.SORT_USER_NAME:
			if(action.params.order == 'asc'){
				state.memberList.sort((a, b) => a.fullName.localeCompare(b.fullName));
			}else{
				state.memberList.sort((a, b) => b.fullName.localeCompare(a.fullName));
			}
			return {
				...state
			};
		
		case directDottedConstants.UPDATE_VELECITY_SUCCESS:
			return {
				...state,
				memberList:action.data,
				status: !state.status
			};
		case directDottedConstants.UPDATE_ACTIVE_TAB:
			state.activeTab = action.activeTab;
			return {
				...state
			};
		case directDottedConstants.GET_DIRECT_DOTED_OKR_SUCCESS:
		return{
			...state,
			directDotedOkr:action.data
		}
		default:
			return {
                ...state
            };
	}
}
export default DirectDotedReducer;